export function isCustomType(source: unknown): source is 'custom' {
  if (typeof source !== 'string') return false

  return source === 'custom'
}
